import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "@/data/store";

import { UploadTask } from "./upload-queue-slice";

export const selectUploadQueue = (state: RootState) => state.uploadQueue.tasks;

/** Select if any unfinished tasks exist, failed included. */
export const selectHasUnfinishedUploads = (state: RootState) =>
  state.uploadQueue.tasks.length > 0;

export const selectFailedUploads = createSelector(selectUploadQueue, (tasks) =>
  tasks.filter((task) => task.status === "failed")
);

export const selectUploadTasksByDialogue = createSelector(
  selectUploadQueue,
  (tasks) => {
    const byDialogue: Record<string, UploadTask[]> = {};
    for (const task of tasks) {
      (byDialogue[task.dialogueId] ??= []).push(task);
    }
    return byDialogue;
  }
);

/**
 * The oldest task the drain loop can work on. An `uploading` task counts,
 * because a crashed or replaced loop can leave one behind.
 */
export const selectNextDrainableTask = (state: RootState) =>
  selectUploadQueue(state).find((task) => task.status !== "failed");
